import Image from 'next/image'

const HeaderBanner = () => {
  return (
    <div className="-mx-4 -mt-4 flex h-[180px] w-[calc(100%+2rem)] items-center justify-center bg-[url('/images/neon-palm.webp')] bg-contain bg-repeat-x md:-mx-6 md:h-[280px] md:w-[calc(100%+3rem)] lg:-mt-8">
      <div className="h-auto w-[90%] md:w-3/4 lg:w-1/2">
        <Image
          src="/images/join-the-party.webp"
          alt="Join the party"
          width={1214}
          height={185}
        />
      </div>
    </div>
  )
}

export default HeaderBanner
